import { useTranslation } from 'react-i18next';
import ShortcutIconSvg from './ShortcutIconSvg.tsx';
import type { FC } from 'react';
import { Suspense } from 'react';
import type { Shortcut } from './type';
import styles from './shortcuts.module.scss';

interface PinnedShortcutTileProps {
  onShortcutNavigate: (shortcut: Shortcut) => void;
  shortcut: Shortcut;
}

const PinnedShortcutTile: FC<PinnedShortcutTileProps> = ({ shortcut, onShortcutNavigate }) => {
  const { i18n } = useTranslation('translation', { keyPrefix: 'shortcuts' });
  const currentLang = i18n.languages[0];
  const { color, iconContent } = shortcut;

  return (
    <div onClick={() => onShortcutNavigate(shortcut)} className={styles.shortcutBox} data-testid="pinned-shortcut-box">
      <div>
        <Suspense fallback={null}>
          <ShortcutIconSvg fill={color} iconContent={iconContent} color={color} />
        </Suspense>
      </div>
      <div className={styles.shortcutText}>
        <div key={shortcut.id} className={styles.title}>
          {shortcut.titles?.[currentLang] ?? shortcut.titles?.['en'] ?? shortcut.title}
        </div>
        <div className={styles.moduleTitle}>{shortcut.moduleTitle}</div>
      </div>
    </div>
  );
};

export default PinnedShortcutTile;
